/**
 * Created by User on 18/04/2016.
 * @name VAST3ErrorCodes
 */
export default {
  /** XML parsing error **/
  XML_PARSING_ERROR: 100,

  /** VAST schema validation error **/
  VAST_VALIDATION_ERROR: 101,

  /** VAST version of response not supported. **/
  VAST_NOT_SUPPORTED: 102,

  /** Trafficking error. Video player received an Ad type that it was not expecting and/or cannot 
	 display **/
  PLAYER_CANNOT_DISPLAY: 200,

  /** Video player expecting different linearity **/
  EXPECTING_DIFFERENT_LINEARITY: 201,

  /** Video player expecting different duration. **/
  EXPECTING_DIFFERENT_DURATION: 202,

  /** Video player expecting different size. **/
  EXPECTING_DIFFERENT_SIZE: 203,

  /** General Wrapper error. **/
  GENERAL_WRAPPER_ERROR: 300,

  /** Timeout of VAST URI provided in Wrapper element, or of VAST URI provided in a subsequent 
	 Wrapper element. (URI was either unavailable or reached a timeout as defined by the video 
	 player.) **/
  VAST_TAG_URI_TIMEOUT: 301,

  /** Wrapper limit reached, as defined by the video player. Too many Wrapper responses have 
	 been received with no InLine response.  **/
  WRAPPER_LIMIT_REACHED: 302,

  /** No Ads VAST response after one or more Wrappers.  **/
  NO_VAST_IN_WRAPPERS: 303,

  /** General Linear error. Video player is unable to display the Linear Ad. **/
  UNABLE_TO_DISPLAY_LINEAR_AD: 400,

  /** File not found. Unable to find Linear/MediaFile from URI. **/
  MEDIAFILE_URI_404: 401,

  /** Timeout of MediaFile URI. **/
  MEDIAFILE_URI_TIMEOUT: 402,

  /** Couldn’t find MediaFile that is supported by this video player, based on the attributes of the 
	 MediaFile element. **/
  COUDNT_FIND_SUPPORTED_MEDIAFILE: 403,

  /** Problem displaying MediaFile. Video player found a MediaFile with supported type but 
	 couldn’t display it. MediaFile may include: unsupported codecs, different MIME type than 
	 MediaFile@type, unsupported delivery method, etc. **/
  COUDNT_DISPLAY_MEDIAFILE: 405,

  /** General NonLinearAds error. **/
  GENERAL_NONLINEAR_ADS_ERROR: 500,

  /** Unable to display NonLinear Ad because creative dimensions do not align with creative 
	 display area (i.e. creative dimension too large). **/
  NONLINEAR_CREATIVE_TOO_LARGE: 501,

  /** Unable to fetch NonLinearAds/NonLinear resource **/
  UNABLE_TO_FETCH_NONLINEAR_ADS: 502,

  /** Couldn’t find NonLinear resource with supported type. **/
  COUDNT_FIND_SUPPORTED_NONLINEAR_RESOURCE: 503,

  /** General CompanionAds error. **/
  GENERAL_COMPANION_AD: 600,

  /** Unable to display Companion because creative dimensions do not fit within Companion
	 display area (i.e., no available space). **/
  NO_AVAILABLE_SPACE_FOR_COMPANION_ADS: 601,

  /** Unable to display Required Companion. **/
  UNABLE_TO_DISPLAY_COMPANION: 602,

  /** Unable to fetch CompanionAds/Companion resource **/
  UNABLE_TO_FETCH_COMPANION: 603,

  /** Couldn’t find Companion resource with supported type **/
  COUDNT_FIND_SUPPORTED_COMPANION_RESOURCE_TYPE: 604,

  /** Undefined Error. **/
  UNDEFINED_ERROR: 900,

  /** General VPAID error **/
  GENERAL_VPAID_ERROR: 901
};